import { LAST_AGENT_ID_STORAGE_KEY } from './rememberLastAgentId';

const readLastAgentId = (): string | null => {
    return sessionStorage.getItem(LAST_AGENT_ID_STORAGE_KEY);
};

export default readLastAgentId;
